const ordersTypes = {
    SAVE_ORDER_HISTORY_START: 'SAVE_ORDER_HISTORY_START',
    GET_USER_ORDER_HISTORY_START: 'GET_USER_ORDER_HISTORY_START',
    SET_USER_ORDER_HISOTRY: 'SET_USER_ORDER_HISOTRY',
    GET_ORDER_DETAILS_START: 'GET_ORDER_DETAILS_START',
    SET_ORDER_DETAILS: 'SET_ORDER_DETAILS',
    UPDATE_ORDER_APPROVAL_STATUS: 'UPDATE_ORDER_APPROVAL_STATUS'
};

export default ordersTypes;